import { render, staticRenderFns } from "./ReporteCobradoCobranza.vue?vue&type=template&id=e56facc2&scoped=true"
import script from "./ReporteCobradoCobranza.vue?vue&type=script&lang=js"
export * from "./ReporteCobradoCobranza.vue?vue&type=script&lang=js"
import style0 from "./ReporteCobradoCobranza.vue?vue&type=style&index=0&id=e56facc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56facc2",
  null
  
)

export default component.exports